module.exports = __webpack_public_path__ + "img/0122.bfb450bf.png";